/**
 * S3.5 - Section "Ingest Outlook" de la page parametres CEE.
 * Affiche : status singleton + 10 derniers events + bouton force run.
 */

import { useEffect, useState } from 'react';
import * as ceeApi from '../../api/cee.js';

/** @returns {JSX.Element} */
export default function IngestAdmin() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [forcing, setForcing] = useState(false);
  const [forceResult, setForceResult] = useState('');

  const load = async () => {
    setLoading(true);
    setError('');
    try {
      const r = await ceeApi.getIngestStatus();
      setData(r);
    } catch (err) {
      setError(err.message || 'Erreur chargement ingest');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const onForceRun = async () => {
    setForcing(true);
    setForceResult('');
    try {
      const r = await ceeApi.forceIngestRun();
      setForceResult('Run termine : ' + JSON.stringify(r));
      await load();
    } catch (err) {
      setForceResult('Erreur : ' + (err.message || 'inconnue'));
    } finally {
      setForcing(false);
    }
  };

  return (
    <section className="bg-white rounded-xl border border-gray-200 p-4 mb-6">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-lg font-bold text-[#0f172a]">Ingest Outlook</h2>
        <button type="button" onClick={onForceRun} disabled={forcing}
          className="px-3 py-1.5 text-sm bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:opacity-50">
          {forcing ? 'Execution...' : 'Forcer execution maintenant'}
        </button>
      </div>
      {error && <div className="bg-red-50 border border-red-200 text-red-700 rounded-md px-3 py-2 mb-3 text-sm">{error}</div>}
      {forceResult && <div className="bg-blue-50 border border-blue-200 text-blue-700 rounded-md px-3 py-2 mb-3 text-xs font-mono">{forceResult}</div>}

      {loading ? <p className="text-sm text-gray-500">Chargement...</p> : (
        <>
          {data && data.state ? (
            <div className="grid grid-cols-2 gap-2 text-sm mb-4">
              <div><span className="text-gray-500">Derniere execution : </span><strong>{data.state.last_run_at ? new Date(data.state.last_run_at).toLocaleString('fr-FR') : 'Jamais'}</strong></div>
              <div><span className="text-gray-500">Statut : </span>
                <span className={`px-2 py-0.5 rounded text-xs ${data.state.last_run_status === 'ok' ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'}`}>
                  {data.state.last_run_status || 'never_run'}
                </span>
              </div>
              <div><span className="text-gray-500">Echecs successifs : </span><strong>{data.state.consecutive_failures || 0}</strong></div>
              <div><span className="text-gray-500">Delta token : </span><code className="text-xs">{data.state.delta_token ? '...' + String(data.state.delta_token).slice(-12) : 'aucun'}</code></div>
              {data.state.last_error && <div className="col-span-2 text-xs text-red-600">Erreur : {data.state.last_error}</div>}
            </div>
          ) : (
            <p className="text-sm text-gray-500">Aucun etat enregistre.</p>
          )}

          <h3 className="text-sm font-semibold text-gray-700 mb-2">10 derniers events ingest</h3>
          <table className="w-full text-xs">
            <thead className="text-gray-500 text-left">
              <tr><th>Date</th><th>Type</th><th>Dossier</th></tr>
            </thead>
            <tbody>
              {(data?.recentEvents || []).map((e) => (
                <tr key={e.id} className="border-t">
                  <td className="py-1">{new Date(e.created_at).toLocaleString('fr-FR')}</td>
                  <td className="font-mono">{e.event_type}</td>
                  <td>{e.dossier_id || '-'}</td>
                </tr>
              ))}
              {(data?.recentEvents || []).length === 0 && (
                <tr><td colSpan="3" className="text-center text-gray-400 py-2">Aucun event</td></tr>
              )}
            </tbody>
          </table>
        </>
      )}
    </section>
  );
}
